
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import api from "./api";

require('./qapp-bootstrap');

window.Vue = require('vue');
let Vue = window.Vue;


const store = Vue.observable({
    items: [],
    workcentre_filter_ids: [],
})

const actions = {
    setItem(item_id, data) {
        let itemIndex = this.getItemIndex(item_id);
        store.items[itemIndex] = data;
    },

    setProcess(item_id, process_id, data) {
        let itemIndex = this.getItemIndex(item_id);
        let processIndex = this.getProcessIndex(item_id, process_id);

        Object.entries(data).forEach(([key, value]) => {
            store.items[itemIndex].production_checklists[processIndex].key = value;
        });
    },

    setProcesses(item_id, data) {
        let itemIndex = this.getItemIndex(item_id);
        store.items[itemIndex].production_checklists = data;
    },

    getItem(item_id) {
        let item = store.items.filter(item => item.id === item_id);
        return item.length ? item[0] : false;
    },
    getProcess(item_id, process_id) {
        let item = this.getItem(item_id);
        if (item === false || item === undefined)
            return false;

        let process = item.production_checklists.filter(process => process.id === process_id);
        return process.length ? process[0] : false;
    },
    getProcessStatus(item_id, process_id) {
        let item = this.getItem(item_id);
        let process = item.production_checklists.filter(process => process.id === process_id)[0];

        if (process.checked === 1)
            return 'done';

        if (process.wc_order_line < 1)
            return 'in_progress';

        let lower_order_processes = item.production_checklists.filter(pcess => pcess.workcentre_order <= process.wc_order_line);
        let checked_sum = _.sumBy(lower_order_processes, 'checked');

        return checked_sum === lower_order_processes.length ? 'in_progress' : 'blocked';
    },
    getItemIndex(item_id) {
        return _.findIndex(store.items, ['id', item_id]);
    },
    getProcessIndex(item_id, process_id) {
        let item = this.getItem(item_id);
        return _.findIndex(item.production_checklists, ['id', process_id]);
    },
}

Vue.prototype.$store = store;
Vue.prototype.$actions = actions;


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// import ProductionProgress from './components/ProductionProgress.vue';
// Vue.component('production-progress', ProductionProgress);

Vue.component('production-progress', require('./components/ProductionProgress').default);
Vue.component('production-dashboard', require('./components/ProductionDashboard').default);
Vue.component('production-stats', require('./components/ProductionStats').default);
Vue.component('production-history', require('./components/production_history/ProductionHistory').default);
Vue.component('production-checklist', require('./components/production_checklist/ProductionChecklist').default);
Vue.component('workcentre-dashboard', require('./components/workcentre_dashboard/WorkcentreDashboard').default);
Vue.component('scribbles', require('./components/scribbles/Scribbles').default);
Vue.component('printers-list', require('./components/printers_list/PrintersList').default);
Vue.component('ai-draft-page', require('./components/ai_draft/AiDraftPage').default);
Vue.component('quote-history', require('./components/quote_history/QuoteHistory').default);
Vue.component('bundle-workshop', require('./components/bundle_workshop/BundleWorkshop').default);
Vue.component('signoff-badge', require('./components/signoff/SignoffBadge').default);
Vue.component('submit-for-signoff-button', require('./components/signoff/SubmitForSignoffButton').default);
Vue.component('signoff-page', require('./components/signoff/SignoffPage').default);
Vue.component('planner-page', require('./components/planner/PlannerPage').default);
Vue.component('staff-dashboard', require('./components/planner/StaffDashboard').default);

// Used for Timer component
Vue.filter('two_digits', function (value) {
    if(value.toString().length <= 1)
        return "0"+value.toString();
    return value.toString();
});

Vue.filter('format_mins_decimal', function (mins) {
    if (Number.isNaN(mins) || mins === 0)
        return '0m';

    let formatted = '';
    let m = Math.trunc(mins) % 60;
    let h = Math.trunc(mins / 60);

    if(h) formatted += h+'h ';
    if(m) formatted += m+'m ';

    if (formatted.length === 0)
        formatted = '0m';

    return formatted;
});

Vue.filter('format_seconds', function (seconds) {
    if (Number.isNaN(seconds) || seconds === 0)
        return '0s';

    let formatted = '';
    let s = Math.trunc(seconds) % 60;
    let m = Math.trunc(seconds / 60) % 60;
    let h = Math.trunc(seconds / 60 / 60) % 24;
    let d = Math.trunc(seconds / 60 / 60 / 24);

    if(d) formatted += d+'d ';
    if(h) formatted += h+'h ';
    if(m) formatted += m+'m ';
    if(s) formatted += s+'s ';

    if (formatted.length === 0)
        formatted = '0s';

    return formatted;
});

Vue.filter('format_seconds_as_mins', function (seconds) {
    return Number.isNaN(seconds) || seconds === 0
        ? '0m'
        : Math.ceil(seconds / 60) + 'm';
});

Vue.filter('format_seconds_short', function (seconds) {
    if (Number.isNaN(seconds) || seconds === 0)
        return '0s';

    let mins = Math.round(seconds / 60);
    let hours = Math.round(mins / 60);

    return mins < 60 ? mins+'m' : hours+'h';
});

Vue.filter('format_seconds_long', function (seconds) {
    if (Number.isNaN(seconds) || seconds === 0)
        return '0 secs';

    let mins = Math.round(seconds / 60);
    let hours = Math.round(mins / 60);

    return mins < 60 ? mins+' mins' : hours+' hours';
});

Vue.filter('format_pence', function (pence) {
    return '£' + (pence / 100);
});

Vue.filter('format_percent', function (percent) {
    return percent + '%';
});

// https://stackoverflow.com/a/56505945
Vue.filter('initials', function (name) {
    if (typeof name !== "string")
        return '?';

    return name
        .replace(/[^A-Za-z0-9À-ÿ ]/ig, '')        // taking care of accented characters as well
        .replace(/ +/ig, ' ')// replace multiple spaces to one
        .split(/ /)                       // break the name into parts
        .reduce((acc, item) => acc + item[0], '') // assemble an abbreviation from the parts
        .concat(name.substr(1))              // what if the name consist only one part
        .concat(name)                             // what if the name is only one character
        .substr(0, 2)                  // get the first two characters an initials
        .toUpperCase();                           // uppercase, but you can format it with CSS as well
});

Vue.filter('maxchars', function (value, length) {
    return value.length <= length ? value : value.substring(0, length-1) + '…';
});

Vue.filter('title_case', function (str) {
    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
});



// https://tahazsh.com/detect-outside-click-in-vue
// // This variable will hold the reference to
// // document's click handler
let handleOutsideClick

Vue.directive('closable', {
    bind (el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
            e.stopPropagation()
            // Get the handler method name and the exclude array
            // from the object used in v-closable
            const { handler, exclude } = binding.value

            // This variable indicates if the clicked element is excluded
            let clickedOnExcludedEl = false
            exclude.forEach(refName => {
                // We only run this code if we haven't detected
                // any excluded element yet
                if (!clickedOnExcludedEl) {

                    // Fix from one of the post comments
                    const excludedEl = vnode.context.$refs[refName];
                    let excludedDomEl = null;
                    if (excludedEl) {
                        // If it's a vue component grab the element, otherwise it is the element
                        excludedDomEl = excludedEl.$el ? excludedEl.$el : excludedEl;
                        clickedOnExcludedEl = excludedDomEl.contains(e.target);
                    }

                }
            })

            // We check to see if the clicked element is not
            // the dialog element and not excluded
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                // If the clicked element is outside the dialog
                // and not the button, then call the outside-click handler
                // from the same component this directive is used in
                vnode.context[handler]()
            }
        }
        // Register click/touchstart event listeners on the whole page
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
    },

    unbind () {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
    }
})
